<script setup>
import Back from '@/assets/icons/svg/back.svg';
import SportLiveTvBadge from '@/sport-live-tv/components/sport-live-tv-badge.vue';
import { useSportLiveTvTranslation } from '@/sport-live-tv/composables/use-sport-live-tv-translation';

defineProps({
  title: { type: String, required: true },
  subtitle: { type: String, default: '' },
  isLive: { type: Boolean, default: false },
});

const emit = defineEmits(['back']);

const { t } = useSportLiveTvTranslation();
</script>

<template>
  <div class="sport-live-tv-player-header">
    <div class="sport-live-tv-player-header__info">
      <button type="button" class="sport-live-tv-player-header__back" :aria-label="t('back')" @click="emit('back')">
        <Back />
      </button>
      <div class="sport-live-tv-player-header__text">
        <h3 class="sport-live-tv-player-header__title">{{ title }}</h3>
        <p v-if="subtitle" class="sport-live-tv-player-header__subtitle">{{ subtitle }}</p>
      </div>
    </div>
    <SportLiveTvBadge v-if="isLive" :label="t('liveLabel')" />
  </div>
</template>

<style lang="scss" scoped>
.sport-live-tv-player-header {
  position: absolute;
  top: 24px;
  right: 24px;
  left: 24px;
  z-index: 2;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;

  &__info {
    display: flex;
    align-items: center;
    gap: 16px;
    min-width: 0;
  }

  &__back {
    flex-shrink: 0;
    padding: 0;
    border: 0;
    background: none;
    cursor: pointer;
  }

  &__text {
    display: flex;
    flex-direction: column;
    min-width: 0;
  }

  &__title,
  &__subtitle {
    margin: 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  &__title {
    color: $white10;
    font-size: 20px;
    font-weight: 600;
  }

  &__subtitle {
    color: $light-gray;
    font-size: 13px;
  }
}
</style>
